import { MenuItem, Typography } from '@mui/material';
import { useContext } from 'react';

import { useAuth0Generic } from '@/hooks/auth';
import {
  IStationSwitcherContext,
  StationSwitcherContext,
} from '@components/providers/station/context';

interface IProfileMenuOptionsProps {
  closeMenu: () => void;
}

export const ProfileMenuOptions = (props: IProfileMenuOptionsProps) => {
  const { logout } = useAuth0Generic();
  const { closeMenu } = props;
  const { onShowStationSelector } = useContext<IStationSwitcherContext>(
    StationSwitcherContext,
  );

  return (
    <>
      <MenuItem
        onClick={() => {
          onShowStationSelector();
          closeMenu();
        }}
      >
        <Typography textAlign="center">Cambiar de estación</Typography>
      </MenuItem>
      <MenuItem
        onClick={() => {
          closeMenu();
          logout();
        }}
      >
        <Typography textAlign="center">Cerrar Sesión</Typography>
      </MenuItem>
    </>
  );
};
